import Button from "../../../../Custom/Button/Button";
import { useEffect, useState } from "react";
import { useGlobalContext } from "../../../../../Context/Context";
import axios from "axios";
import VazecaTabela from "./VazecaTabela";
import ArhiviranaTabela from "./ArhiviranaTabela";

const styles = {
  button: {
    padding: "5px 30px",
    fontWeight: "bold",
    width: "17vw",
    height: "5vh",
  },
};

function Akt() {
  const [vazecaDokumenta, setVazecaDokumenta] = useState([]);
  const [arhiviranaDokumenta, setArhiviranaDokumenta] = useState([]);
  const [workplaces, setWorkplaces] = useState([]);

  const [checkedRowsVazeci, setCheckedRowsVazeci] = useState([]);
  const [isCheckedAllVazeci, setIsCheckedAllVazeci] = useState(false);

  const [checkedRowsArhivirani, setCheckedRowsArhivirani] = useState([]);
  const [isCheckedAllArhivirani, setIsCheckedAllArhivirani] = useState(false);

  const { dictionary, baseUrl, selectedMainEntity, apiKey, loggedUser } = useGlobalContext();
  const company_id = selectedMainEntity?.company_id;

  useEffect(() => {
    if (!company_id) return;
    fetchData();
    window.addEventListener("aktAdded", fetchData);
    return () => window.removeEventListener("aktAdded", fetchData);
  }, [company_id]);

  const fetchData = async () => {
    try {
      const { data } = await axios.post(`${baseUrl}/akt/read.php`, { company_id });
      if (data.status === 200) {
        console.log(data)
        setVazecaDokumenta(data.vazeca || []);
        setArhiviranaDokumenta(data.arhivirana || []);
        setWorkplaces(data.workplaces || []);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const moveToArhivirani = async (dokument) => {
    try {
      const res = await axios.post(`${baseUrl}/akt/archive.php`, { id: dokument.id });
      if (res.data.status === 200) {
        setArhiviranaDokumenta((prev) => [...prev, { ...dokument, status_dokumenta: "ARHIVIRAN" }]);
        setVazecaDokumenta((prev) => prev.filter((d) => d.id !== dokument.id));
      }
    } catch (e) { console.error(e); }
  };

  const moveToVazeci = async (dokument) => {
  try {
    const payload = {
      api_key: apiKey,
      user_id: loggedUser.id,
      id: dokument.id
    };

    const { data } = await axios.post(`${baseUrl}/akt/restore_document.php`, payload);

    if (data.status === 200) {
      // Skloni iz arhive na ekranu
      setArhiviranaDokumenta((prev) => prev.filter((d) => d.id !== dokument.id));
      
      // Dodaj u vazeća na ekranu
      setVazecaDokumenta((prev) => [...prev, { ...dokument, arhiviran: 0 }]);
    } else {
      alert(data.message);
    }
  } catch (error) {
    console.error("Greška:", error);
    alert("Greška pri povezivanju sa serverom.");
  }
};

  const handleDodaj = () => {
    const globalnoDodavanjeInput = document.getElementById("globalno-dodavanje-input");
    if (!globalnoDodavanjeInput) return;
    globalnoDodavanjeInput.value = "";
    globalnoDodavanjeInput.click();
  };

  return (
    <div
      style={{
        padding: "5px",
        backgroundColor: "rgb(204, 204, 204)",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <div
        style={{
          overflowY: "auto",
          backgroundColor: "white",
          border: "1.5px solid #9f9f9f",
          padding: "5px",
          height: "100%",
        }}
      >
        <VazecaTabela
          dokumenta={vazecaDokumenta}
          moveToArhivirani={moveToArhivirani}
          checkedRows={checkedRowsVazeci}
          setCheckedRows={setCheckedRowsVazeci}
          isCheckedAll={isCheckedAllVazeci}
          setIsCheckedAll={setIsCheckedAllVazeci}
          workplaces={workplaces}
        />

        <div style={{ marginTop: "5px" }}>
          <ArhiviranaTabela
            dokumenta={arhiviranaDokumenta}
            setDokumenta={setArhiviranaDokumenta}
            moveToVazeci={moveToVazeci}
            checkedRows={checkedRowsArhivirani}
            setCheckedRows={setCheckedRowsArhivirani}
            isCheckedAll={isCheckedAllArhivirani}
            setIsCheckedAll={setIsCheckedAllArhivirani}
          />
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "15px",
        }}
      >
        <div style={{ display: "flex", gap: "10px" }}>
          <div>
            <Button activation={true} style={styles.button}>
              {dictionary["stampaj"]}
            </Button>
          </div>
          <div>
            <Button activation={true} style={styles.button}>
              {dictionary["posalji"]}
            </Button>
          </div>
        </div>
        <div onClick={handleDodaj}>
          <Button activation={true} style={styles.button}>
            {dictionary["dodajNoviDokument"]}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Akt;